import React from 'react'
import {connect} from 'react-redux'
import {Fill} from 'react-slot-fill'
import {
  changeTemplate,
  autoSaveRemove,
  autoSaveOrder,
  autoSaveUpdate,
  saveCompleteDocument,
  updateReportSettings
} from 'report-components/lib/reducers'
import {withToggles, withPopupToggles} from 'startlibs/lib/hocs'
import {SaveTemplateDialog} from './SaveTemplateDialog'
import {postFetcher} from '../../reducers'

@connect((state) => ({
    isSaving: state.appUI.loadings[autoSaveUpdate] || state.appUI.loadings[autoSaveRemove] || state.appUI.loadings[autoSaveOrder] || state.appUI.loadings[changeTemplate] || state.appUI.loadings[updateReportSettings] || false,
    isChangingTemplate: state.appUI.loadings[changeTemplate]
  }),
  {changeTemplate}
)
@withPopupToggles('contextMenu')
@withToggles('overwriteDialog', 'saveNewDialog')
export class TemplateSelector extends React.Component {

  static defaultProps = {
    selectLabel: 'Report template'
  }

  constructor(props) {
    super(props)
    this.state = {selectedTemplate: props.selectedTemplate}
  }

  componentWillReceiveProps(newProps) {
    if (!newProps.isChangingTemplate && this.props.isChangingTemplate) {
      if (newProps.selectedTemplate !== this.state.selectedTemplate) {
        this.setState({templateJustChanged: true, selectedTemplate: newProps.selectedTemplate})
        saveCompleteDocument()
        setTimeout(() => this.setState({templateJustChanged: false}), 5 * 1000)
      } else {
        this.setState({templateChangeFailed: true})
        setTimeout(() => this.setState({templateChangeFailed: false}), 5 * 1000)
      }
    }
  }


  closeJustChanged = () => this.setState({templateJustChanged: false})

  overwriteTemplate = (options) =>
    this.saveTemplate({...options, templateId: this.props.selectedTemplate.templateId})

  saveTemplate = (template) => {
    const result = this.props.saveTemplate(state => this.props.prepareTemplateToSave(template)(state))
    result.then(({errors,success:{id}}) => !errors && id && postFetcher('changeTemplate', {templateId:id}))
    return result
  }

  render() {
    const {
      templates,
      selectedTemplate,
      contextMenu,
      changeTemplate,
      reportTitle,
      dicomInfo,
      availableSignatures,
      overwriteDialog,
      withoutSignatures,
      saveNewDialog,
      openManageTemplatesDialog,
      isChangingTemplate,
      selectLabel
    } = this.props
    const {templateChangeFailed, templateJustChanged} = this.state
    return (
      <div className="report-template-info">
            <span className="dropdown-only-text-button"
                  onClick={contextMenu.toggle}>{selectLabel}: {selectedTemplate.label}</span>
        {contextMenu.isOpen &&
        <ul className="context-menu">
          {templates.available.length > 0 && <li className="section-heading">Switch report template</li>}
          {templates.available.map(template =>
            <li
              onClick={() => changeTemplate(template.templateId, {dicomInfo, availableSignatures})}
              key={template.templateId}
              className={template.templateId === selectedTemplate.templateId ? 'selected' : ''}
            >
              <a>{template.label}</a>
            </li>)}
          {templates.available.length > 0 && <li className="separator"/>}
          <li className="section-heading">Save fields as a template</li>
          {
            selectedTemplate.templateId !== undefined &&
            <li onClick={overwriteDialog.open}><a>
              <span className="icon icon-reload"/>Overwrite "{selectedTemplate.label}"
            </a></li>
          }
          <li onClick={saveNewDialog.open}><a><span className="icon icon-plus-circle"/>Save as new
            template</a></li>
          <li className="separator"/>
          <li className="manage-templates" onClick={openManageTemplatesDialog}><a><span
            className="icon icon-files"/>Manage report templates</a></li>
        </ul>}
        {
          overwriteDialog.isOpen &&
          <SaveTemplateDialog
            withoutSignatures={withoutSignatures}
            availableTemplates={templates.available}
            save={this.overwriteTemplate}
            formProperties={{
              label: selectedTemplate.label,
              keepSignatures: true,
              keepContent: true
            }}
            closeDialog={overwriteDialog.close}
            overwritingTemplate={selectedTemplate}/>
        }
        {
          saveNewDialog.isOpen &&
          <SaveTemplateDialog
            withoutSignatures={withoutSignatures}
            availableTemplates={templates.available}
            save={this.saveTemplate}
            formProperties={{
              label: reportTitle? reportTitle.title : "" ,
              keepSignatures: true,
              keepContent: true
            }}
            closeDialog={saveNewDialog.close}/>
        }
        {(isChangingTemplate || templateJustChanged || templateChangeFailed) &&
        <Fill name="Notifications">
          {isChangingTemplate && <div className="system-notification with-loader"><span>Changing template</span></div>}
          {templateJustChanged &&
          <div className="system-notification success "><span>Template changed successfully</span> <a
            className="icon icon-x" onClick={this.closeJustChanged}/></div>}
          {templateChangeFailed && <div className="system-notification error "><span>Template changed failed, please try again or contact Purview</span>
            <a className="icon icon-x" onClick={this.closeJustChanged}/></div>}
        </Fill>
        }
      </div>

    )
  }

}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/template/TemplateSelector.jsx